export const getLPPlusParams = () => {
  const params = new URLSearchParams(window.location.search);
  const plus = params.get('plus') === 'true';
  const app = params.get('app') === 'true';
  return { plus, app };
};
